import React from "react";
import { Mail, Rocket, Heart } from "lucide-react";

const steps = [
  {
    n: "01",
    icon: Mail,
    title: "Regístrate hoy",
    desc: "Déjanos tu correo. Prometemos que solo te llegará una notificación: el día del lanzamiento del libro.",
  },
  {
    n: "02",
    icon: Rocket,
    title: "Lanzamiento oficial",
    desc: "Cuando abramos la campaña para comprar el libro, tendrás acceso anticipado en la plataforma de crowdfunding.",
  },
  {
    n: "03",
    icon: Heart,
    title: "Mucho más que un libro",
    desc: "Con cada libro, estás aportando a Oceana, la mayor organización mundial para la protección de los océanos.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how"
      data-testid="how-section"
      className="relative py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="text-center max-w-2xl mx-auto mb-20">
          <span className="text-xs uppercase tracking-[0.2em] font-medium text-cyan-400">
            Cómo funciona
          </span>
          <h2 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight mt-4 mb-5 leading-tight">
            De tu correo al océano,
            <br />
            en tres pasos.
          </h2>
          <p className="text-lg text-slate-300">
            Para que sepas exactamente qué pasa cuando dejas tu correo.
          </p>
        </div>

        <div
          data-testid="steps-grid"
          className="grid grid-cols-1 md:grid-cols-3 gap-6 relative"
        >
          {/* Connecting line */}
          <div className="hidden md:block absolute top-12 left-[16.67%] right-[16.67%] h-px bg-gradient-to-r from-transparent via-cyan-400/40 to-transparent" />

          {steps.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={i}
                data-testid={`step-${i}`}
                className="relative bg-slate-900/40 border border-white/5 hover:border-cyan-400/30 rounded-2xl p-8 transition-all duration-500 hover:-translate-y-1 backdrop-blur-sm"
              >
                <div className="flex items-center justify-between mb-7">
                  <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-cyan-500/20 to-cyan-500/5 border border-cyan-400/30 flex items-center justify-center">
                    <Icon className="w-6 h-6 text-cyan-400" />
                  </div>
                  <span className="font-heading text-5xl font-extrabold text-slate-800">
                    {s.n}
                  </span>
                </div>
                <h3 className="font-heading text-xl font-bold mb-3">
                  {s.title}
                </h3>
                <p className="text-slate-400 leading-relaxed text-sm">
                  {s.desc}
                </p>
              </div>
            );
          })}
        </div>

        <div className="mt-16 text-center">
          <a
            href="#register"
            data-testid="how-cta-button"
            className="inline-flex items-center gap-2 bg-cyan-500 hover:bg-cyan-400 text-slate-950 font-bold px-8 py-4 rounded-full transition-all duration-300 shadow-[0_0_20px_rgba(34,211,238,0.3)] hover:shadow-[0_0_30px_rgba(34,211,238,0.5)] hover:-translate-y-1"
          >
            Quiero mi libro
          </a>
        </div>
      </div>
    </section>
  );
}
